import ComponentElement from 'components/component-element';
import Search from 'components/search-v2';
import {
    getCookie,
    shouldShowBookingCounterFromCookie,
    hasTouristOrderCookie,
    normalizeNewHeaderIconOnlyCounter,
} from 'methods/utils';
import {ajaxGetData} from 'methods/ajaxData';
import Layout from 'components/layout';

/**
 * Верхний поиск для десктопа
 */
function Header($element, options = {}) {
    window.isHeaderInit = 1;

    // наследование
    ComponentElement.call(this, $element, options);

    this._states = [];

    // для верх поиска
    this.$wrapper           = this.$element.querySelector('.js-headerWrapper');
    this.$openSearch        = this.$element.querySelector('.js-openSearch');
    this.$searchPlate       = this.$element.querySelector('.js-searchPlate');
    this.$searchBlock       = this.$element.querySelector('.js-searchBlock');
    this.$searchFormWrapper = this.$element.querySelector('.js-searchFormWrapper');
    this.$hideSearchBlock   = document.querySelector('.js-hideSeachBlock');
    this.$pageSearch        = document.querySelector('.js-pageSearch');

    if (this.options.search) {
        // поля на плашке
        this.$citySearch   = this.$openSearch.querySelector('.js-citySearch');
        this.$periodSearch = this.$openSearch.querySelector('.js-periodSearch');
        this.$peopleSearch = this.$openSearch.querySelector('.js-peopleSearch');

        // открытие модалки
        this.$openSearch.addEventListener('click', this.open.bind(this));

        this.search = new Search(this.$pageSearch, options);

        if (this.options.openDatePickerWithoutDates && !this.search.hasDates() && !getCookie('date_start') && !getCookie('date_finish')) {
            this.search.openDatePicker();
        }

        // событие change формы поиска
        const self = this;
        
        this.search.on('change', this._onSearchChangeEvent.bind(this));
        this.search.on('submit', function(data) {
            if (this.hasDates()) {
                self._onSearchSubmitEvent(data);
                return;
            }

            this.cancelSubmition();
            this.openDatePicker();
        });

        // кнопка поиска
        this.search.on('searchButton', this.close.bind(this));

        // клик на "фон"
        this.$element.addEventListener('click', this._onElementClickEvent.bind(this));

        ajaxGetData().then(r => this.search.setData(r.data.search));
    }

    // скрыть / показать поиск в шапке
    if (this.options.fixed && this.$hideSearchBlock && this.$searchBlock) {
        window.addEventListener('scroll', this._onWindowScrollEvent.bind(this));
    }

    this.$menuWrapper = this.$element.querySelector('.js-headerMenuWrapper');
    this.menu = new HeaderUserMenu(this.$menuWrapper);

    Layout.scroll.track(this.$wrapper);

    this.update();
}

// наследование
Header.prototype = Object.create(ComponentElement.prototype);

// цепочка прототипов
Object.defineProperty(Header.prototype, 'constructor', {
    value: Header,
    writable: true,
    enumerable: false,
});

Header.prototype.setOptions = function(options) {
    ComponentElement.prototype.setOptions.call(this, Object.assign({
        fixed: false,
        search: false,
        zIndexActive: 100,
    }, options));
}

Header.prototype.opened = function() {
    return this.$element.classList.contains('Header--search-modal');
}

Header.prototype.open = function() {
    this._toggleVisibility(true);
    this.emit('open');
}

Header.prototype.close = function() {
    this._toggleVisibility(false);
    this.emit('close');
}

Header.prototype.getFixed = function() {
    return this.$element.classList.contains('is-scrolled');
}

Header.prototype.setFixed = function(state) {
    state = !!state;

    const currentState = this.getFixed();
    if (currentState != state) {
        this.$element.classList.toggle('is-scrolled', state);
        this.emit('fixed', state);
    }

    return currentState;
}

Header.prototype.getSearchPlateVisibility = function() {
    if (!this.$searchBlock) {
        return false;
    }

    return !this.$searchBlock.classList.contains('is-hidden');
}

Header.prototype.setSearchPlateVisibility = function(state) {
    if (!this.$searchBlock) {
        return;
    }

    this.$searchBlock.classList.toggle('is-hidden', !state);
    this.$searchBlock.style.opacity = state ? 1 : 0;
}

Header.prototype.toFront = function(state) {
    this.$element.style.zIndex = state ? this.options.zIndexActive : '';
}

Header.prototype.pushStates = function() {
    this._states.push({
        fixed: this.getFixed(),
        searchPlateVisibility: this.getSearchPlateVisibility(),
        toFront: this.$element.style.zIndex,
    });
}

Header.prototype.popStates = function() {
    const state = this._states.pop();
    this.setFixed(state.fixed);
    this.setSearchPlateVisibility(state.searchPlateVisibility);
    this.toFront(state.toFront);
}

// рендер данных поиска на плашке
Header.prototype.renderPlate = function() {
    if (this.$openSearch) {
        this.$citySearch.textContent   = this.search.getCitySearch();
        this.$periodSearch.textContent = this.search.getPeriodSearch();
        this.$peopleSearch.textContent = this.search.getPeopleSearch();
    }
}

// данные для поиска
Header.prototype.setSearchData = function(data) {
    this.search.setData(data);
    this.renderPlate();
}

// данные для поиска
Header.prototype.getSearchData = function() {
    return this.search.getData();
}

Header.prototype.update = function() {
    this.setFixed(window.pageYOffset > 0);

    if (this.$hideSearchBlock && this.$searchBlock) {
        const top = this.$hideSearchBlock.getBoundingClientRect().top - 84;
        this.setSearchPlateVisibility(top < 0 && !this.opened());
    }

    this.emit('update');
}

// показываем/скрываем верхний поиск
Header.prototype._toggleVisibility = function(visibility) {
    this.$element.classList.toggle('Header--search-modal', visibility);
    this.$wrapper.classList.toggle('Search--background', visibility);
    this.$wrapper.classList.toggle('Search--background-none', visibility);
    this.$searchPlate.classList.toggle('is-hidden', !visibility);

    if (visibility) {
        this.$searchFormWrapper.innerHTML = '';
        this.$searchFormWrapper.append(this.search._$form);
        this.search._$form.classList.add('search-v2--top-search');
        Layout.scroll.disable();
    } else {
        this.$pageSearch.innerHTML = '';
        this.$pageSearch.append(this.search._$form);
        this.search._$form.classList.remove('search-v2--top-search');
        Layout.scroll.enable();
    }

    this.update();
}

Header.prototype._onSearchChangeEvent = function(data) {
    this.renderPlate();
    this.emit('search:change', data);
}

Header.prototype._onSearchSubmitEvent = function(data) {
    this.emit('search:submit', data);
}

Header.prototype._onElementClickEvent = function(e) {
    if (this.$element !== e.target) {
        return false;
    }

    this.close();
}

Header.prototype._onWindowScrollEvent = function() {
    this.update();
}

function HeaderUserMenu($element, options = {}) {
    // наследование
    ComponentElement.call(this, $element, options);

    if (shouldShowBookingCounterFromCookie()) {
        this._renderBookingCounter({});
    }

    this.fetch().then(r => {
        this._renderBookingCounter(r.data);

        if (r.data.user_header_render && r.data.user_header_render.length) {
            this.$element.querySelectorAll('[data-remove-on-auth]').forEach($item => $item.remove());
            this.$element.innerHTML += r.data.user_header_render;
        }

        this.$userMenu = this.$element.querySelector('.js-headerUserMenu');
        this.$userMenuWrapper = this.$element.querySelector('.js-headerUserMenuWrapper');
        this.$userMenuOpen = this.$element.querySelector('.js-headerUserMenuOpen');

        if (this.$userMenuOpen) {
            this.$userMenuOpen.addEventListener('click', this.toggle.bind(this));
            document.dispatchEvent(new CustomEvent('header-user-menu:ready'));
        }
    }).catch(e => {
        //
    });
}

// наследование
HeaderUserMenu.prototype = Object.create(ComponentElement.prototype);

// цепочка прототипов
Object.defineProperty(HeaderUserMenu.prototype, 'constructor', {
    value: HeaderUserMenu,
    writable: true,
    enumerable: false,
});

HeaderUserMenu.prototype._updateBookingCounter = function($counter, bookingPageUrl, hasUnpaidOrders) {
    if ($counter.tagName === 'A') {
        $counter.href = bookingPageUrl;
    } else {
        const $form = $counter.closest('form');
        if ($form) {
            $form.action = bookingPageUrl;
        }
    }

    if (hasUnpaidOrders) {
        $counter.setAttribute('data-unpaid', '');
    } else {
        $counter.removeAttribute('data-unpaid');
    }

    normalizeNewHeaderIconOnlyCounter($counter, 'Мои поездки');
};

HeaderUserMenu.prototype._renderBookingCounter = function(data = {}) {
    const hasTouristOrders = Boolean(data.has_tourist_orders) || hasTouristOrderCookie();
    if (!hasTouristOrders) {
        return;
    }

    if (this.$element.querySelector('.js-bookingCounter') || document.querySelector('.js-bookingCounter')) {
        const $existing = this.$element.querySelector('.js-bookingCounter') || document.querySelector('.js-bookingCounter');
        const bookingPageUrl = data.booking_page_url || (data.tourist_auth ? '/lk/booking/' : '/my/booking/');
        const hasUnpaidOrders = Boolean(data.has_unpaid_orders) || Boolean(document.querySelector('.js-booking-unpaid-toast'));

        this._updateBookingCounter($existing, bookingPageUrl, hasUnpaidOrders);
        return;
    }

    const bookingPageUrl = data.booking_page_url || (data.tourist_auth ? '/lk/booking/' : '/my/booking/');
    const hasUnpaidOrders = Boolean(data.has_unpaid_orders) || Boolean(document.querySelector('.js-booking-unpaid-toast'));
    const $kurortButtons = this.$element.closest('.Kurort-header__buttons');
    if ($kurortButtons) {
        const $menu = $kurortButtons.querySelector('.Kurort-header__menu');
        const $booking = document.createElement('a');

        $booking.className = 'Kurort-header__booking Kurort-header__counter js-bookingCounter';
        $booking.href = bookingPageUrl;
        $booking.setAttribute('data-remove-on-auth', '');
        $booking.setAttribute('aria-label', 'Перейти в мои поездки');
        $booking.setAttribute('title', 'Мои поездки');
        if (hasUnpaidOrders) {
            $booking.setAttribute('data-unpaid', '');
        }

        $booking.innerHTML = `
            <span class="Kurort-header__counter-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M19.0029 21.004H4.99705C3.89202 21.004 2.99622 20.1081 2.99622 19.0031V9.99937C2.99622 8.89434 3.89202 7.99854 4.99705 7.99854H19.0029C20.1079 7.99854 21.0037 8.89434 21.0037 9.99937V19.0031C21.0037 20.1081 20.1079 21.004 19.0029 21.004Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M16.0016 21.0039V5.99766C16.0016 4.89263 15.1058 3.99683 14.0008 3.99683H9.99912C8.89409 3.99683 7.99829 4.89263 7.99829 5.99766V21.0039" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </span>
        `;

        if ($menu) {
            $kurortButtons.insertBefore($booking, $menu);
        } else {
            $kurortButtons.append($booking);
        }

        document.dispatchEvent(new CustomEvent('booking-counter:ready'));
        return;
    }

    const $newHeaderMenu = this.$element.closest('.js-userEnterBlockNew') || this.$element;
    const $favorite = $newHeaderMenu.querySelector('.New-header__favorite');
    const $firstMenuItem = $newHeaderMenu.querySelector('.New-header__menu-item');
    const $booking = document.createElement('form');

    $booking.className = 'New-header__booking';
    $booking.action = bookingPageUrl;
    $booking.method = 'GET';
    $booking.setAttribute('data-remove-on-auth', '');
    $booking.innerHTML = `
        <button class="New-header__booking New-header__counter New-header__counter--iconOnly js-bookingCounter" type="submit" aria-label="Перейти в мои поездки" title="Мои поездки"${hasUnpaidOrders ? ' data-unpaid' : ''}>
            <span class="New-header__counter-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M19.0029 21.004H4.99705C3.89202 21.004 2.99622 20.1081 2.99622 19.0031V9.99937C2.99622 8.89434 3.89202 7.99854 4.99705 7.99854H19.0029C20.1079 7.99854 21.0037 8.89434 21.0037 9.99937V19.0031C21.0037 20.1081 20.1079 21.004 19.0029 21.004Z" stroke="#316BFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M16.0016 21.0039V5.99766C16.0016 4.89263 15.1058 3.99683 14.0008 3.99683H9.99912C8.89409 3.99683 7.99829 4.89263 7.99829 5.99766V21.0039" stroke="#316BFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </span>
        </button>
    `;

    if ($firstMenuItem) {
        $newHeaderMenu.insertBefore($booking, $firstMenuItem);
    } else if ($favorite && $favorite.nextSibling) {
        $newHeaderMenu.insertBefore($booking, $favorite.nextSibling);
    } else {
        $newHeaderMenu.append($booking);
    }

    document.dispatchEvent(new CustomEvent('booking-counter:ready'));
}

HeaderUserMenu.prototype.fetch = function() {
    return ajaxGetData();
}

HeaderUserMenu.prototype.toggle = function() {
    if (this.opened()) {
        this.close();
    } else {
        this.open();
    }
}

HeaderUserMenu.prototype.opened = function() {
    return this.$userMenuWrapper.classList.contains('open');
}

HeaderUserMenu.prototype.open = function() {
    if (this.opened()) {
        return;
    }

    this.$userMenuWrapper.classList.add('open');
    document.addEventListener('click', this._onDocumentClickEventBind = this._onDocumentClickEvent.bind(this));
    document.dispatchEvent(new CustomEvent('header-user-menu:open'));
}

HeaderUserMenu.prototype.close = function() {
    if (!this.opened()) {
        return;
    }

    this.$userMenuWrapper.classList.remove('open');
    document.removeEventListener('click', this._onDocumentClickEventBind);
    document.dispatchEvent(new CustomEvent('header-user-menu:close'));
}

HeaderUserMenu.prototype._onDocumentClickEvent = function(e) {
    if (this.$element.contains(e.target)) {
        return;
    }

    this.close();
}

export function initHeaderBookingFromCookie() {
    if (!shouldShowBookingCounterFromCookie()) {
        return;
    }

    document.querySelectorAll('.js-headerMenuWrapper').forEach(($menuWrapper) => {
        const menu = Object.create(HeaderUserMenu.prototype);
        menu.$element = $menuWrapper;
        menu._renderBookingCounter({});
    });
}

export default Header;
